import React, { useState, useEffect, useRef } from "react";

const Dropdown = ({
    label = "Select Item",
    options = [],
    selectedItems = [],
    setSelectedItems,
}) => {
    const dropdownRef = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    const toggleItemSelection = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter((i) => i !== item));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredOptions = options.filter((option) =>
  typeof option === "string" &&
  option.toLowerCase().includes(searchTerm.toLowerCase())
);


    return (
        <>
            {isDropdownOpen && (
                <div
                    onClick={() => setIsDropdownOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "transparent",
                        zIndex: 999,
                        pointerEvents: "auto",
                    }}
                />
            )}

            <div
                className="dropdown"
                ref={dropdownRef}
                style={{ position: "relative", zIndex: isDropdownOpen ? 1000 : 0 }}
            >
                <button
                    type="button"
                    onClick={toggleDropdown}
                    style={{
                        border: selectedItems.length > 0 
                            ? "1px solid rgba(79, 70, 229, 0.5)" 
                            : "1px solid #E4E4E7",
                        backgroundColor: selectedItems.length > 0 
                            ? "#F3F4F6" 
                            : "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "12px",
                        fontWeight: "500",
                        boxShadow: isDropdownOpen
                            ? "0px 0px 4px rgba(79, 70, 229, 0.5)"
                            : selectedItems.length > 0
                            ? "0px 0px 2px rgba(79, 70, 229, 0.3)"
                            : "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        transition: "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out",
                        minWidth: "100px",
                        textAlign: "left",
                    }}
                    className="btn"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            fontSize: "12px"
                        }}
                    >
                        <span>{label}</span>
                        <span style={{ fontSize: "12px", marginLeft: "8px" }}>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="black"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                                />
                            </svg>
                        </span>
                    </div>
                </button>

                {isDropdownOpen && (
                    <ul
                        className="dropdown-menu show p-2"
                        style={{
                            width: "270px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            backgroundColor: "#fff",
                            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                            borderRadius: "5px",
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            zIndex: 1001,
                            marginTop: "1px",
                        }}
                    >
                        <div className="border p-2 rounded mb-2">
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "6px",
                                    alignItems: "center",
                                }}
                            >
                                {selectedItems.length > 0 ? (
                                    selectedItems.map((item, index) => (
                                        <span
                                            key={index}
                                            className="bg-dark text-white px-2 py-1 rounded d-flex align-items-center"
                                            style={{
                                                fontSize: "12px",
                                            }}
                                        >
                                            {item}
                                            <button
                                                type="button"
                                                className="btn-close btn-sm ms-2"
                                                aria-label="Close"
                                                onClick={() => toggleItemSelection(item)}
                                                style={{
                                                    filter: "invert(1)",
                                                    border: "none",
                                                    padding: "0",
                                                    width: "12px",
                                                    height: "12px",
                                                }}
                                            />
                                        </span>
                                    ))
                                ) : (
                                    <span className="text-muted">Select Items</span>
                                )}
                            </div>
                        </div>

                        <li>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </li>

                        {/* <div className="mt-2 w-full">
                            {filteredOptions.length > 0 ? (
                                filteredOptions.map((option) => (
                                    
                                    <li
                                        key={option}
                                        className="d-flex justify-content-between align-items-center py-1 border-bottom"
                                    >
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={selectedItems.includes(option)}
                                                onChange={() => toggleItemSelection(option)}
                                            />
                                            <label className="form-check-label  m-0 fs-12">{option}</label>
                                           
                                        </div>
                                        
                                    </li>

                                ))
                            ) : (
                                <li className="text-muted text-center mt-2">No matches found</li>
                            )}
                        </div> */}
                        <div style={{
                         maxHeight: "100px",
                                overflowY: "auto",
                                scrollbarHeight: "5px",
                                scrollbarWidth: "thin",
                            
                        }}>
                            <ul className="list-unstyled m-0 p-0">
                                {filteredOptions.length > 0 ? (
                                    filteredOptions.map((option) => (
                                        <li
                                            key={option}
                                            className="d-flex justify-content-between align-items-center py-1 border-bottom px-2"
                                        >
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    checked={selectedItems.includes(option)}
                                                    onChange={() => toggleItemSelection(option)}
                                                />
                                                <label className="form-check-label m-0 fs-12">
                                                    {option}
                                                </label>
                                            </div>
                                        </li>
                                    ))
                                ) : (
                                    <li className="text-muted text-center mt-2">No matches found</li>
                                )}
                            </ul>
                        </div>


                    </ul>
                )}
            </div>
        </>
    );
};

export default Dropdown;
